import React from 'react'
import { useTools } from "../../ToolProvider.jsx";

const shapes = [
    {
        key: 'rect',
        label: 'Rectángulo',
        icon: (
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.5} className="w-5 h-5">
                <rect x="3" y="6" width="18" height="12" rx="1" />
            </svg>
        ),
    },
    {
        key: 'circle',
        label: 'Círculo',
        icon: (
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.5} className="w-5 h-5">
                <circle cx="12" cy="12" r="9" />
            </svg>
        ),
    },
    {
        key: 'triangle',
        label: 'Triángulo',
        icon: (
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.5} className="w-5 h-5">
                <path strokeLinejoin="round" d="M12 4 L21 20 H3 Z" />
            </svg>
        ),
    },
    {
        key: 'diamond',
        label: 'Diamante',
        icon: (
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.5} className="w-5 h-5">
                <path strokeLinejoin="round" d="M12 3 L21 12 L12 21 L3 12 Z" />
            </svg>
        ),
    },
    {
        key: 'star',
        label: 'Estrella',
        icon: (
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.5} className="w-5 h-5">
                <path strokeLinejoin="round" d="M12 2l2.9 6.2L22 9.3l-5.1 4.9 1.2 7-6.1-3.3-6.1 3.3 1.2-7L2 9.3l7.1-1.1Z" />
            </svg>
        ),
    },
    {
        key: 'pentagon',
        label: 'Pentágono',
        icon: (
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.5} className="w-5 h-5">
                <path strokeLinejoin="round" d="M12 2 L21.5 8.9 L17.9 20.1 H6.1 L2.5 8.9 Z" />
            </svg>
        ),
    },
    {
        key: 'hexagon',
        label: 'Hexágono',
        icon: (
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.5} className="w-5 h-5">
                <path strokeLinejoin="round" d="M12 2 L21 7 L21 17 L12 22 L3 17 L3 7 Z" />
            </svg>
        ),
    },
    {
        key: 'octagon',
        label: 'Octógono',
        icon: (
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.5} className="w-5 h-5">
                <path strokeLinejoin="round" d="M8.5 2h7l4.5 4.5v7L15.5 22h-7L4 17.5v-7Z" />
            </svg>
        ),
    },
];

const DropdownAddShape = ({ className, 'data-tip': dataTip }) => {
    const { onAddTriangle, onAddCircle, onAddRectangle,
            onAddPentagon, onAddHexagon, onAddOctagon,
            onAddStar, onAddDiamond } = useTools();

    const handlers = {
        rect:     onAddRectangle,
        circle:   onAddCircle,
        triangle: onAddTriangle,
        diamond:  onAddDiamond,
        star:     onAddStar,
        pentagon: onAddPentagon,
        hexagon:  onAddHexagon,
        octagon:  onAddOctagon,
    };

    return (
        <div className={`dropdown dropdown-bottom ${className} z-50`} data-tip={dataTip}>
            <label tabIndex="0" className="p-0 cursor-pointer" title="Añadir formas">
                <IconShapes className="w-10 h-10" />
            </label>
            <ul tabIndex="0" className="dropdown-content menu p-2 shadow bg-base-100 rounded-box w-44 z-50">
                {shapes.map(({ key, label, icon }) => (
                    <li key={key}>
                        <button
                            onClick={handlers[key]}
                            className="flex items-center gap-2 text-sm py-1.5"
                        >
                            {icon}
                            <span>{label}</span>
                        </button>
                    </li>
                ))}
            </ul>
        </div>
    );
};

function IconShapes(props) {
    return (
        <svg
            {...props}
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
        >
            <rect x="2" y="2" width="8" height="8" rx="1" strokeWidth="1.5" />
            <circle cx="18" cy="6" r="4" strokeWidth="1.5" />
            <path strokeLinecap="round" strokeLinejoin="round" d="M12 14l5 8H7l5-8Z" />
        </svg>
    );
}

export default DropdownAddShape;
